import style from "./CapacityFilter.css";
import { useEffect, useRef, useContext } from "preact/hooks";

import { Tag } from "../Tag";
import { capacityOptions } from "../static-data";
import {
  isMobileScreen,
  handleDropdownClose,
  handleDropdownOpen,
} from "../../helpers";

import { Context } from "../Context";

const CapacityFilter = ({ capacityFilter, onCapacitySelect }) => {
  const [context, setContext] = useContext(Context);
  const node = useRef();

  // useEffect(() => {
  //   window.addEventListener("popstate", handlePop);
  //   return () => {
  //     document.removeEventListener("popstate", handlePop);
  //   };
  // }, []);

  // const handlePop = (event) => {
  //   if (window.location.search.indexOf("capacityOpen") >= 0) {
  //     setContext({ ...context, filterOpen: "capacityOpen" });
  //   } else {
  //     if (window.location.search.indexOf("capacityOpen") < 0) {
  //       setContext({ ...context, filterOpen: "" });
  //     }
  //   }
  // };

  const handleCapacityFilterOpen = () => {
    handleDropdownOpen("capacityOpen");
    setContext({ filterOpen: "capacityOpen" });
  };

  const handleCapacityFilterClose = () => {
    handleDropdownClose("capacityOpen");
    setContext({ filterOpen: "" });
  };

  const renderListItemStyle = (key) =>
    key === capacityFilter ? style.selectedListItem : style.listItem;

  const handleCapacityClick = (key) => {
    if (key === capacityFilter) {
      onCapacitySelect("");
    } else {
      onCapacitySelect(key);
    }
  };

  const conditionalMobileHeader = () => {
    if (!isMobileScreen()) return null;
    if (isMobileScreen()) {
      return (
        <div class={style.mobileCapacityHeader}>
          <div
            class={style.closeIcon}
            onClick={handleCapacityFilterClose}
          ></div>
          <h4>Gäste</h4>
          <div class={style.hidden}>x</div>
        </div>
      );
    }
  };

  const getText = () => {
    if (capacityFilter && capacityFilter.length > 0)
      return capacityFilter.toString() + " Gäste";
    return "Gäste";
  };

  const checkDisabled = () => {
    if (!capacityFilter) return style.disableClear;
  };

  const conditionalRenderDropdown = () => {
    if (context.filterOpen === "capacityOpen")
      return (
        <div
          class={style.capacityFilter}
          onClick={() => {
            if (!isMobileScreen()) {
              handleCapacityFilterClose();
            }
          }}
        >
          <div
            class={style.capacityFilterContainer}
            style={{
              left: node.current.base.getBoundingClientRect().left + "px",
              top: node.current.base.getBoundingClientRect().top + "px",
            }}
          >
            {conditionalMobileHeader()}
            <div class={style.capacityListContainer}>
              <ul class={style.capacityUl}>
                {capacityOptions.map((capacity) => (
                  <li
                    key={capacity.key}
                    class={renderListItemStyle(capacity.key)}
                    onClick={() => {
                      handleCapacityClick(capacity.key);
                      handleCapacityFilterClose();
                    }}
                  >
                    {capacity.text}
                  </li>
                ))}
              </ul>
            </div>

            <div class={style.filterBoxBottom}>
              <span
                class={style.clearAllFilters + " " + checkDisabled()}
                onClick={() => {
                  onCapacitySelect("");
                  handleCapacityFilterClose();
                }}
              >
                Löschen
              </span>
              <button
                style={{ color: "white" }}
                onClick={handleCapacityFilterClose}
              >
                Speichern
              </button>
            </div>
          </div>
        </div>
      );
    return null;
  };
  return (
    <Fragment>
      <Tag
        ref={node}
        text={getText()}
        hasDropdown={true}
        shouldTruncate={true}
        selected={capacityFilter && capacityFilter.length !== 0}
        onClick={handleCapacityFilterOpen}
      />
      {conditionalRenderDropdown()}
    </Fragment>
  );
};

export { CapacityFilter };
